
/* Pup Pad v4 Advertorial: Buybox in den Warenkorb (Drawer), FAQ einzeln, Teilen. */
(function () {
  'use strict';
  function start() {
    var form = document.getElementById('a4-form');
    if (form) {
      var knopf = form.querySelector('.a4-bbknopf');
      var pfad = function (d) { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + d; };
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') { return; }   /* ohne Drawer: normaler POST, Shopify leitet auf /cart */
        e.preventDefault();
        if (knopf.classList.contains('a4-laedt')) { return; }
        knopf.classList.add('a4-laedt');
        var daten = new FormData(form);
        daten.delete('return_to');
        daten.append('sections', 'cart-drawer,cart-icon-bubble');
        daten.append('sections_url', window.location.pathname);
        fetch(pfad('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: daten })
          .then(function (r) { return r.json(); })
          .then(function (a) {
            if (a.status) { throw new Error(a.description || 'Warenkorb'); }
            drawer.classList.remove('is-empty');
            try { drawer.renderContents(a); } catch (f) {
              try { drawer.open(); } catch (g) { window.location.href = pfad('cart'); }
            }
            setTimeout(function () {
              if (!drawer.classList.contains('active') && !drawer.hasAttribute('open')) { window.location.href = pfad('cart'); }
            }, 1500);
          })
          .catch(function () { window.location.href = pfad('cart'); })
          .then(function () { knopf.classList.remove('a4-laedt'); });
      });
    }
    [].slice.call(document.querySelectorAll('[data-a4-faq]')).forEach(function (l) {
      var d = [].slice.call(l.querySelectorAll('details'));
      d.forEach(function (x) { x.addEventListener('toggle', function () { if (x.open) { d.forEach(function (y) { if (y !== x) { y.open = false; } }); } }); });
    });
    [].slice.call(document.querySelectorAll('[data-a4-teilen]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var u = window.location.href.split('?')[0];
        if (navigator.share) { navigator.share({ title: document.title, url: u }).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(u); b.setAttribute('aria-label', 'Link kopiert'); }
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
